import { Component, signal, WritableSignal, ChangeDetectionStrategy, Input, forwardRef } from '@angular/core';
import { ClickOutSideDirective } from '@directives/click-out-side.directive';
import { LnChevronDownSvgIconComponent } from '@components/svg-icons/ln-chevron-down-svg-icon/ln-chevron-down-svg-icon.component';
import { NgClass } from '@angular/common';
import { LeftCheckboxAndLabelComponent } from '@components/left-checkbox-and-label/left-checkbox-and-label.component';
import { CheckBoxAndLabelInterface } from '@interfaces/contact/check-box-and-label-interface';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'ln-contact-page-form-drop-down',
  imports: [ClickOutSideDirective, LnChevronDownSvgIconComponent, NgClass, LeftCheckboxAndLabelComponent],
  templateUrl: './contact-page-form-drop-down.component.html',
  styleUrl: './contact-page-form-drop-down.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR, // ✅ tell Angular this component is a CVA
      useExisting: forwardRef(() => ContactPageFormDropDownComponent),
      multi: true,
    },
  ],
})
export class ContactPageFormDropDownComponent implements ControlValueAccessor {
  // para que no ve valide error
  value = '1';
  disabled = false;

  protected options: WritableSignal<string[]> = signal([]);
  protected isOpen: WritableSignal<boolean> = signal(false);
  @Input({ required: true }) showContactOptionError!: WritableSignal<boolean>;
  @Input({ required: true }) listOfOptions: WritableSignal<CheckBoxAndLabelInterface>[] | undefined;
  protected selectedOptions: CheckBoxAndLabelInterface[] = [];
  protected selected: WritableSignal<string> = signal('');

  // private TAG = 'ContactPageFormDropDownComponent';

  updateSelectedOptions(checkBoxAndLabelInterface: CheckBoxAndLabelInterface): void {
    if (checkBoxAndLabelInterface.state) {
      this.selectedOptions.push(checkBoxAndLabelInterface);
      this.selected.set(checkBoxAndLabelInterface.label);
    } else {
      this.selectedOptions = this.selectedOptions.filter(value => value.id !== checkBoxAndLabelInterface.id);
      if (this.selectedOptions.length > 0) {
        this.selected.set(this.selectedOptions[this.selectedOptions.length - 1].label);
      } else {
        this.selected.set('');
      }
    }
    // this.showContactOptionError.set(this.selectedOptions.length == 0);
  }

  toggleDropdown() {
    if (this.listOfOptions && this.listOfOptions.length > 0) {
      this.isOpen.set(!this.isOpen());
      // this.showContactOptionError.set(this.selectedOptions.length == 0);
    }
  }

  closeDropdown() {
    if (this.isOpen()) {
      this.isOpen.set(false);
      this.showContactOptionError.set(this.selectedOptions.length == 0);
    }
  }

  //   ControlValueAccessor interface methods:

  // CVA callbacks (Angular sets these)
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private onChange: (val: string) => void = () => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private onTouched: () => void = () => {};

  writeValue(val: string | null): void {
    this.value = val ?? '';
  }

  registerOnChange(fn: (val: string) => void) {
    this.onChange = fn;
  }
  registerOnTouched(fn: () => void) {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
